export default "__VITE_ASSET__Ds7P7zma__"